import { Loader } from 'react-feather';
import ManageTable from '../../../Manage/ManageTable';
import PopupModal from '../../../Manage/PopupModal';
import { getImageURL } from '../../../../snippets/snippets';
import image from '../../../../assets/images/static-image.jpg'
import { useEffect, useState } from 'react';

const FollowedStores = () => {
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);

    const [modal, setModal] = useState(false);
    const handleModal = () => setModal(!modal);

    // Mock data
    const mockData = [
            {
                store_name: "Brand store name 1",
                status: "Following",
                action: "Visit store",
                image: "",
                submission_date:'30 March 2024',
            },
            {
                store_name: "Brand store name 2",
                status: "Following",
                action: "Visit store",
                image: "",
                submission_date:'30 March 2024',
            },
            {
                store_name: "Brand store name 3",
                status: "Following",
                action: "Visit store",
                image: "",
                submission_date:'30 March 2024',
            }
        
    ];

    useEffect(() => {
        // Simulate fetching data
        setTableData(mockData);
        setLoading(false);
    }, []);

    const columns = [
        {
            name: "Store Name",
            cell: (row) => 
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={ row.image !== "" ? getImageURL(row.image) : image} 
                        style={{borderRadius:"50%", height:"35px", width:"35px"}} />
                        &ensp;
                        &ensp; 
                    <span title={row.store_name} className="ellipsis">{row.store_name}</span>
                </div>,
            selector: (row) => row.store_name,
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => <span title={row.status} className="ellipsis">{row.status}</span>,
            selector: (row) => row.status,
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => <span title={row.action} className="ellipsis">{row.action}</span>,
            selector: (row) => row.action,
            sortable: true,
        },
    ];

    return (
        <>
            <div>
                {loading ? <Loader /> :
                    <ManageTable
                        name={'Followed Stores'}
                        columns={columns}
                        setTableData={setTableData}
                        tableData={tableData}
                    />
                }
            </div>

            <PopupModal
                company_id={''}
                open={modal}
                setModal={setModal}
                handleModal={handleModal}
                name={''}
                tableData={''}
                setTableData={''}
            />
        </>
    );
}

export default FollowedStores;
